@for (ilo of iloValues$ | async; track ilo.id) {
<div class="form-check">
    <input
        id="ilo-select-{{ ilo.id }}-{{ subFormId() }}"
        class="form-check-input"
        type="checkbox"
        [value]="ilo.id"
        [checked]="isChecked(ilo.id)"
        [disabled]="disabled"
        (change)="onToggle(ilo.id)"
    />
    <label
        for="ilo-select-{{ ilo.id }}-{{ subFormId() }}"
        class="form-check-label"
    >
        {{ ilo.intendedOutcome }}
    </label>
</div>
} @empty {
<p class="text-muted small" i18n>
    No ILOs available. Add some in the previous step.
</p>
}
